<template>
    <!--意向场地-->
    <!--:value-key="type=='object'?'id':''-->
    <el-select :multiple="multiple" :clearable="clearable"   :disabled="disabled" :value="value"   @change="change" :size="size" :placeholder="placeholder" >
        <el-option
                v-for="item in list"
                :key="item.id"
                :label="item.houseName"
                :value="item.id">
        </el-option>
    </el-select>

</template>

<script>
    export default {
        name: "want-house",
        props:{
            size:String,
            placeholder:String,
            multiple:Boolean,
            disabled:Boolean,
            clearable:Boolean,
            value:[Array,Object,String],
            // type:String
        },
        model:{
            prop:'value'
        },
        data(){
            return{
                list:[],
                data:'',
            }
        },
        mounted(){
            this.getData();

        },
        methods:{
            getData(){
                this.$axios.get("/house/houseListByStoreId/"+this.$root.getStorage('storeId')).then(res=>{
                   console.log(res.data.list)
                    this.list=res.data.list;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            change(value){
                console.log('选中',value)
                if(value){
                    if(this.multiple){//多选
                        var a=[];
                        this.list.filter((item)=>{
                            for(var i in value){
                                if(item.id==value[i]){
                                    a.push(item);
                                    break;
                                }
                            }
                        });
                        this.$emit('change',a);

                    }else{//单选

                        var data= this.list.filter((item)=>item.id==value);
                        console.log(111,data)
                        this.$emit('change',data[0]);
                    }

                }else{

                    this.$emit('change',value);
                }
                this.$emit('input',value);
            }
        }
    }
</script>

<style scoped>

</style>